import React, { lazy } from 'react';
import { motion } from 'framer-motion';
const bonuses = [{
  num: 1,
  title: 'El Rescate de Actividades para Todo el Año',
  desc: 'Banco de actividades listas para resolver cualquier clase en minutos.',
  image: 'https://cdn.magicpatterns.com/uploads/vgVoqVFQxuA8ME8eitztHW/bonus_1_El_Rescate_de_Actividades_para_Todo_el_Ano.webp'
}, {
  num: 2,
  title: 'Efemérides Resueltas sin Estrés',
  desc: 'Propuestas concretas para cada fecha especial del calendario escolar.',
  image: 'https://cdn.magicpatterns.com/uploads/tRtXxsbHe75c3LAbRWYFF4/Bonus_2_Efemerides_Resueltas_sin_Estres.webp'
}, {
  num: 3,
  title: 'Informes y Registros que Sí Dan Ganas de Usar',
  desc: 'Modelos listos para documentar sin perder horas redactando.',
  image: 'https://cdn.magicpatterns.com/uploads/pBLHqjuW1mZmN8xPTdHwZa/Bonus_3_Informes_y_Registros_que_Si_Dan_Ganas_de_Usar.webp'
}, {
  num: 4,
  title: 'La Agenda Invisible de la Docente Organizada',
  desc: 'Planillas y checklists para bajar la carga mental y ordenar la semana.',
  image: 'https://cdn.magicpatterns.com/uploads/1Na93yuDunzW5hgZokaabQ/Bonus_4_La_Agenda_Invisible_de_la_Docente_Organizada.webp'
}, {
  num: 5,
  title: 'Imprimibles que Te Salvan la Semana',
  desc: 'Recursos visuales listos para imprimir y usar de inmediato en sala.',
  image: 'https://cdn.magicpatterns.com/uploads/dR2t8C49LFGezPyVovngC1/Bonus_5_Imprimibles_que_Te_Salvan_la_Semana.webp'
}];
export function BonusesSection() {
  return <section className="py-16 md:py-24 bg-white pt-[30px] pb-[30px]" data-id="element-12">
      <div className="container mx-auto px-4 max-w-[1100px]" data-id="element-13">
        <div className="text-center mb-12" data-id="element-14">
          <h2 className="font-heading font-extrabold text-[#1a2e5a] text-3xl md:text-5xl leading-tight mb-4" data-id="element-15">
            Material Complementario
          </h2>
          <p className="text-xl md:text-2xl text-slate-600 font-bold" data-id="element-16">
            Y además, te llevás estos Bonos Exclusivos
          </p>
        </div>

        <div className="space-y-6 max-w-4xl mx-auto" data-id="element-17">
          {bonuses.map((b, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.08
        }} className="bg-[#f8f8f8] border border-slate-200 rounded-3xl p-6 md:p-8 shadow-sm flex flex-col md:flex-row gap-6 items-center" data-id="element-18">
              <div className="flex-shrink-0 w-full md:w-44 relative" data-id="element-19">
                <img src={b.image} alt={`Bono ${b.num}: ${b.title}`} width={400} height={400} loading="lazy" decoding="async" className="w-full h-48 md:h-44 object-cover rounded-2xl shadow-md" data-id="element-20" />
                <span className="absolute top-2 left-2 inline-flex items-center bg-[#b5623d] text-white font-extrabold text-[11px] tracking-wide uppercase px-3 py-1.5 rounded-full shadow-md" data-id="element-21">
                  Bonus {b.num}
                </span>
                <span className="absolute top-2 right-2 inline-flex items-center gap-1 bg-[#5a7d4f] text-white font-extrabold text-[11px] tracking-wide uppercase px-3 py-1.5 rounded-full shadow-md" data-id="element-22">
                  <span className="text-sm" data-id="element-23">🎁</span> Gratis
                </span>
              </div>
              <div className="flex-grow w-full text-center md:text-left" data-id="element-24">
                <p className="text-slate-600 text-[16px] leading-relaxed" data-id="element-25">
                  {b.desc}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}